// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__1CX15","mainActive":"App_mainActive__3TLQx"};